import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import AdminLayout from "../layout/AdminLayout";
import Home from "../pages/Home/Home";
import Contact from "../pages/Contact/Contact";
import Dashboard from "../pages/Admin/Dashboard/Dashboard";
import { LoadingProvider } from "../context/LoadingContext"; 
import NewsandArticles from "../pages/NewsandArticles/NewsandArticles";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "../pages/TermsConditions/TermsConditions";

const LayoutSelector = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin"); // ตรวจสอบ path

  return isAdmin ? <AdminLayout /> : <MainLayout />;
};

const AppRoutes = () => {
  return (
    <Router>
      <LoadingProvider>
        <Routes>
          <Route path="/" element={<LayoutSelector />}>
            {/* Main Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/newsandarticles" element={<NewsandArticles />} />
            <Route path="/termsConditions" element={<TermsConditions />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            {/* Admin Pages */}
            <Route path="/admin/dashboard" element={<Dashboard />} />

          </Route>
        </Routes>
      </LoadingProvider>
    </Router>
  );
};

export default AppRoutes;
